module.exports = __webpack_public_path__ + "static/media/lower-monthly-payment.ff73a508.svg";